import React from 'react';
import styled from '@emotion/styled';
import GooglePlayBadge from './GooglePlayBadge.png';

const StyledImage = styled.img`
  margin: -10px;
`;

export default ({ ...props }) => <StyledImage src={GooglePlayBadge} alt="Google Play Store Badge" {...props} />;
